import RefreshAuth from "./refresh";
import RevokeAuth from "./revoke";
export const baseUrl = "https://api.mundipagg.com/auth/v2";
export default axiosConfig => ({
  refresh: RefreshAuth(axiosConfig),
  revoke: RevokeAuth(axiosConfig)
});